import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

function Footer() {

    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    // Load user from localStorage on component mount
    useEffect(() => {
        const storedUser = localStorage.getItem('User');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // Listen for logout or session expiration
    useEffect(() => {
        const handleLogoutEvent = async () => {
            setUser(null);
        };

        const handleLoginEvent = () => {
            setUser(JSON.parse(localStorage.getItem('User')));
        };

        window.addEventListener('login', handleLoginEvent);

        window.addEventListener('logout', handleLogoutEvent);
        return () => {
            window.addEventListener('login', handleLoginEvent);

            window.removeEventListener('logout', handleLogoutEvent);
        };
    }, []);

    return (
        <div className="container"> 
            <footer className="pt-4 my-md-5 pt-md-5 border-top">
            <div className="row">
                <div className="col-12 col-md">
                    <img className="mb-2" src="/DecipherX_Logo1.svg" alt="" width="72" height="72" style={{ cursor: "pointer" }} onClick={() => navigate("/")} />
                    <small className="d-block mb-3 text-body-secondary">© 2026, All rights reserved.</small>
                </div>
                <div className="col-6 col-md">
                    <h5>Features</h5>
                    <ul className="list-unstyled text-small">
                        <li className="mb-1">
                            <Link className="link-secondary text-decoration-none" to="/Home">Audio Transcriptions</Link>
                            {/* <a className="link-secondary text-decoration-none" href="#"></a> */}
                        </li>
                        <li className="mb-1">
                            <Link className="link-secondary text-decoration-none" to="/Home">Image To Text</Link>
                            {/* <a className="link-secondary text-decoration-none" href="#">Image To Text</a> */}
                        </li>
                    </ul>
                </div>
                <div className="col-6 col-md">
                    <h5>Resources</h5>
                    <ul className="list-unstyled text-small">
                        <li className="mb-1"><a className="link-secondary text-decoration-none" href="/dev-docs/AudioTranscription" 
                        // onClick={(e) => { e.preventDefault(); user && navigate("/dev-docs/AudioTranscription"); }}
                        >API Documenttion</a></li>
                    </ul>
                </div>
                <div className="col-6 col-md">
                    <h5>About</h5>
                    <ul className="list-unstyled text-small">
                        <li className="mb-1">
                            <Link className="link-secondary text-decoration-none" to="/AboutUs">About Us</Link>
                        </li>
                        <li className="mb-1">
                            <Link className="link-secondary text-decoration-none" to="/Terms" target="_blank">Terms & Conditions</Link>
                        </li>
                        {/* <li className="mb-1"><a className="link-secondary text-decoration-none" href="#">Privacy</a></li>
                        <li className="mb-1"><a className="link-secondary text-decoration-none" href="#">Terms</a></li> */}
                    </ul>
                </div>
            </div>
        </footer>
        </div>
        
    );
}

export default Footer;